/**
 * Helpers for localStorage that scope keys per user sub.
 * If no sub is provided, operations are no-ops to avoid storing data for unauthenticated users.
 */
const buildKey = (sub, key) => {
  if (!sub || !key) return null;
  return `${sub}:${key}`;
};

export const scopedStorage = {
  get(sub, key) {
    const scopedKey = buildKey(sub, key);
    if (!scopedKey) return null;
    return localStorage.getItem(scopedKey);
  },
  set(sub, key, value) {
    const scopedKey = buildKey(sub, key);
    if (!scopedKey) return;
    localStorage.setItem(scopedKey, value);
  },
  remove(sub, key) {
    const scopedKey = buildKey(sub, key);
    if (!scopedKey) return;
    localStorage.removeItem(scopedKey);
  },
};

export default scopedStorage;
